import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/info-circle.svg'
import _imports_1 from '@/assets/images/input-search-dark.svg'
import _imports_2 from '@/assets/images/input-search.svg'


const _hoisted_1 = _imports_1
const _hoisted_2 = { class: "connector-layout" }
const _hoisted_3 = { class: "start-charging__title" }
const _hoisted_4 = { class: "start-charging__info" }
const _hoisted_5 = { class: "start-charging__main" }
const _hoisted_6 = { class: "label" }
const _hoisted_7 = { class: "input-with-icon" }
const _hoisted_8 = ["placeholder"]
const _hoisted_9 = { class: "input-info" }
const _hoisted_10 = {
  key: 0,
  class: "form-group"
}
const _hoisted_11 = { class: "label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_2, [
    _createVNode($setup["PageHeader"], { "header-class": 'header--start-charging' }, {
      default: _withCtx(() => [
        _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.$t("chargingPage.connectorLayout.title")), 1),
        _createElementVNode("div", _hoisted_4, [
          _cache[3] || (_cache[3] = _createElementVNode("img", {
            class: "start-charging__icon",
            src: _imports_0,
            alt: ""
          }, null, -1)),
          _createElementVNode("p", null, _toDisplayString(_ctx.$t("chargingPage.connectorLayout.subTitle")), 1)
        ])
      ]),
      _: 1
    }),
    _createElementVNode("main", _hoisted_5, [
      _createElementVNode("form", {
        class: "form-group",
        onSubmit: _cache[2] || (_cache[2] = _withModifiers(($event: any) => ($setup.search()), ["prevent"]))
      }, [
        _createElementVNode("label", _hoisted_6, _toDisplayString(_ctx.$t("chargingPage.connectorLayout.plsTypeChargerId")), 1),
        _createElementVNode("div", _hoisted_7, [
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.chargerId) = $event)),
            class: "input",
            type: "number",
            placeholder: _ctx.$t('chargingPage.connectorLayout.chargerId')
          }, null, 8, _hoisted_8), [
            [_vModelText, $setup.chargerId]
          ]),
          _createElementVNode("picture", {
            class: "input-icon",
            onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.search()))
          }, [...(_cache[4] || (_cache[4] = [
            _createElementVNode("source", {
              srcset: _hoisted_1,
              media: "(prefers-color-scheme: dark)"
            }, null, -1),
            _createElementVNode("img", {
              src: _imports_2,
              alt: ""
            }, null, -1)
          ]))])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("p", null, _toDisplayString($setup.address), 1)
        ])
      ], 32),
      ($setup.connectors.length > 0)
        ? (_openBlock(), _createElementBlock("form", _hoisted_10, [
            _createElementVNode("label", _hoisted_11, _toDisplayString(_ctx.$t("chargingPage.connectorLayout.hint")), 1),
            ($props.startCallIsLoading)
              ? (_openBlock(), _createBlock($setup["LoadingComponent"], { key: 0 }))
              : (_openBlock(), _createBlock($setup["ConnectorsComponent"], {
                  key: 1,
                  connectors: $setup.connectors,
                  onConnectorselected: $setup.connectorSelected
                }, null, 8, ["connectors"]))
          ]))
        : _createCommentVNode("", true),
      ($setup.submitIsLoading)
        ? (_openBlock(), _createBlock($setup["LoadingComponent"], { key: 1 }))
        : _createCommentVNode("", true)
    ]),
    ($setup.isConfirmModalActive)
      ? (_openBlock(), _createBlock($setup["ConfirmModal"], {
          key: 0,
          "yes-button-color-class": "btn-primary",
          "main-title": $setup.confirmMainTitle,
          "sub-title": _ctx.$t('chargingPage.confirm.startCharging.subTitle'),
          "yes-title": _ctx.$t('chargingPage.confirm.startCharging.yesTitle'),
          "no-title": _ctx.$t('chargingPage.confirm.startCharging.noTitle'),
          onConfirm: $setup.confirmCharge,
          onCancel: $setup.handleConfirmModalCancel
        }, null, 8, ["main-title", "sub-title", "yes-title", "no-title"]))
      : _createCommentVNode("", true),
    ($setup.isFeedbackModalActive)
      ? (_openBlock(), _createBlock($setup["FeedbackModal"], {
          key: 1,
          "main-title": _ctx.$t('errors.connectorErrors.notFoundError.mainTitle'),
          "sub-title": _ctx.$t('errors.connectorErrors.notFoundError.subTitle'),
          success: false,
          onConfirm: $setup.handleFeedbackModalOkClick
        }, null, 8, ["main-title", "sub-title"]))
      : _createCommentVNode("", true)
  ]))
}